/* ============================================================
   EXHIBELA theme scripts
   - sticky header + mobile nav
   - scroll reveal
   - AJAX cart drawer (Section Rendering API)
   - product variant selection + gallery
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money formatter ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || '${{amount}}';
    var pat = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, p, t, d) {
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (t || ','));
      var cents = parts[1] ? (d || '.') + parts[1] : '';
      return dollars + cents;
    }
    switch ((fmt.match(pat) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = defaultTo(cents, 2, "'", '.'); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(pat, value);
  }
  window.exhibelaMoney = formatMoney;

  /* ---------- header ---------- */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 20); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    document.addEventListener('click', function (e) {
      var burger = e.target.closest('[data-burger]');
      if (burger) {
        var nav = document.querySelector('.mobile-nav');
        if (nav) nav.classList.toggle('open');
      }
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var reveal = function (el) { el.classList.add('in'); };
    var all = function () { return document.querySelectorAll('.reveal:not(.in)'); };
    var vh = window.innerHeight || 800;
    all().forEach(function (e) { if (e.getBoundingClientRect().top < vh * 0.94) reveal(e); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.06, rootMargin: '0px 0px -6% 0px' });
      all().forEach(function (e) { io.observe(e); });
    } else { all().forEach(reveal); }
    setTimeout(function () { all().forEach(reveal); }, 1100);
  }

  /* ---------- cart drawer ---------- */
  var DRAWER_ID = 'shopify-section-cart-drawer';

  function openDrawer() { document.body.classList.add('cart-open'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }

  function setBubble(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    var wrap = document.getElementById(DRAWER_ID);
    if (!wrap) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById(DRAWER_ID);
    wrap.innerHTML = fresh ? fresh.innerHTML : html;
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBubble(c.item_count); })
      .catch(function () {});
  }

  function addToCart(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[data-add-btn]');
    var origText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

    var body = { items: [{ id: Number(idInput.value), quantity: Number(qtyInput && qtyInput.value || 1) }],
                 sections: ['cart-drawer'] };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { if (btn) btn.innerHTML = res.d.description || 'Unavailable'; setTimeout(function(){ if(btn){btn.disabled=false;btn.innerHTML=origText;} },1600); return; }
        if (res.d.sections) renderDrawer(res.d.sections['cart-drawer']);
        refreshCount();
        openDrawer();
        if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(function () { btn.disabled = false; btn.innerHTML = origText; }, 1400); }
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = origText; } });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
        setBubble(cart.item_count);
        // if on the cart page, reload to reflect changes
        if (document.querySelector('[data-cart-page]')) window.location.reload();
      })
      .catch(function () {});
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
      var step = e.target.closest('[data-line-step]');
      if (step) {
        e.preventDefault();
        var key = step.getAttribute('data-key');
        var q = parseInt(step.getAttribute('data-qty'), 10);
        changeLine(key, q < 0 ? 0 : q);
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-key'), 0); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // product add-to-cart forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (form) { e.preventDefault(); addToCart(form); }
    });
  }

  /* ---------- product page: variants + qty + gallery ---------- */
  function initProduct() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var section = form.closest('[data-product-root]') || document;
      var dataEl = section.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
      var idInput = form.querySelector('[name="id"]');
      var addBtn = form.querySelector('[data-add-btn]');
      var priceEl = section.querySelector('[data-price]');
      var addLabel = form.querySelector('[data-add-label]');

      function currentOptions() {
        var opts = [];
        form.querySelectorAll('[data-option-position]').forEach(function (group) {
          var pos = parseInt(group.getAttribute('data-option-position'), 10);
          var checked = group.querySelector('input:checked');
          if (checked) opts[pos - 1] = checked.value;
        });
        return opts;
      }
      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function update() {
        var opts = currentOptions();
        var v = findVariant(opts);
        // reflect checked styling
        form.querySelectorAll('[data-swatch],[data-size]').forEach(function (lbl) {
          var input = lbl.querySelector('input');
          if (input) lbl.toggleAttribute('data-checked', input.checked);
        });
        // update displayed option value labels
        form.querySelectorAll('[data-selected-value]').forEach(function (s) {
          var grp = s.closest('.opt').querySelector('[data-option-position]') || s.closest('.opt');
          var checked = s.closest('.opt').querySelector('input:checked');
          if (checked) s.textContent = checked.value;
        });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; }
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }
        idInput.value = v.id;
        try { if (v.featured_image && v.featured_image.src) { var pm = document.querySelector('[data-gallery-main] img'); if (pm) pm.src = v.featured_image.src; } } catch (err) {}
        if (priceEl) {
          var html = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html = '<span class="was">' + formatMoney(v.compare_at_price, moneyFormat) + '</span>';
          }
          html += '<span>' + formatMoney(v.price, moneyFormat) + '</span>';
          priceEl.innerHTML = html;
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('[name^="option"],input[type="radio"]')) update();
      });
      update();

      // qty stepper
      form.querySelectorAll('[data-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = form.querySelector('[name="quantity"]');
          var val = parseInt(input.value, 10) || 1;
          val += parseInt(b.getAttribute('data-qty-btn'), 10);
          input.value = Math.max(1, val);
        });
      });
    });

    // gallery thumbnails
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main] img');
      gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (main && src) main.src = src;
          gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- cart page qty steppers (native form) ---------- */
  function initCartPage() {
    document.querySelectorAll('[data-cart-page] [data-cart-qty]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = wrap.querySelector('input');
          var val = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-btn'), 10);
          input.value = Math.max(0, val);
          input.form && input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
        });
      });
    });
  }

  function init() {
    initHeader();
    initReveal();
    initCart();
    initProduct();
    initCartPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // re-run reveal after section reloads in the theme editor
  document.addEventListener('shopify:section:load', function () { initReveal(); initProduct(); });
})();
